// extracted by mini-css-extract-plugin
module.exports = {"layout":"locales_layout__IEFnU","toggle":"locales_toggle__sIAmS","overlay":"locales_overlay__YDev8","active":"locales_active__wOfB1","localeButton":"locales_localeButton__0aQp_"};